import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-done-circle-icon',
  templateUrl: './code-done-circle.component.html'
})
export class CodeDoneCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
